export default (theme) => ({
    panelBottom: {
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1203,
        '@media (min-width:381px) and (max-width:767px)': {
            right: 10,
            bottom: 10
        },
        '@media (max-width: 380px)': {
            right: 10,
            bottom: 10
        }
    }
});